import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { fmtUSDStrict, timeAgo } from "@/lib/format";
import { ShieldCheck, AlertTriangle, ArrowRight } from "lucide-react";

export const ShariahWatchCard = () => {
  const navigate = useNavigate();
  const [s, setS] = useState(null);

  useEffect(() => {
    api.get("/shariah/watch").then(({ data }) => setS(data.summary)).catch(() => {});
  }, []);

  if (!s || !s.screened) return null;
  const clean = s.needs_review === 0;

  return (
    <Card className="p-5 shadow-premium" data-testid="dashboard-shariah-card">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 text-sm font-semibold">
          <ShieldCheck className="h-4 w-4 text-emerald-600" />Shariah Watch
        </div>
        <span className="text-[10px] text-muted-foreground">
          {s.last_screened ? timeAgo(s.last_screened) : "not screened"}
        </span>
      </div>

      <div className="flex items-end gap-2">
        <span className="numeric text-3xl font-bold">{s.compliant_value_pct}%</span>
        <span className="text-xs text-muted-foreground mb-1">of your portfolio is Shariah compliant</span>
      </div>
      <div className="mt-3 h-2 rounded-full bg-muted overflow-hidden flex">
        <div className="h-full bg-emerald-500" style={{ width: `${s.compliant_value_pct}%` }} />
        <div className="h-full bg-amber-400 flex-1" />
      </div>

      <div className="mt-3 space-y-1.5 text-xs">
        <div className="flex justify-between">
          <span className="text-muted-foreground">Holdings screened</span>
          <span className="numeric font-semibold">{s.screened}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-muted-foreground">Needs review</span>
          <span className={`numeric font-semibold ${clean ? "" : "text-amber-600"}`}>{s.needs_review}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-muted-foreground">Income to purify</span>
          <span className="numeric font-semibold">{fmtUSDStrict(s.purification_owed_usd)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-muted-foreground">Next re-screen</span>
          <span className="numeric">{s.next_due || "—"}</span>
        </div>
      </div>

      {!clean && (
        <div className="mt-3 flex items-start gap-1.5 text-[11px] text-amber-700 bg-amber-50 rounded-xl p-2.5"
          data-testid="dashboard-shariah-warning">
          <AlertTriangle className="h-3.5 w-3.5 mt-0.5 shrink-0" />
          {s.needs_review} holding{s.needs_review > 1 ? "s" : ""} no longer pass every AAOIFI screen.
        </div>
      )}

      <Button variant="outline" size="sm" className="w-full mt-3 h-8 text-xs"
        onClick={() => navigate("/shariah-watch")} data-testid="dashboard-shariah-cta">
        Open Shariah Watch <ArrowRight className="h-3.5 w-3.5 ms-1" />
      </Button>
    </Card>
  );
};
